import { useContext } from 'react';

import { IconLockOutline } from '@zillow/constellation';
import { Box, Text } from '@zillow/constellation-10';

import { FreemiumContext } from '../../../Freemium/context';

const PremiumUpgrade = () => {
  const { freemiumState } = useContext(FreemiumContext);

  const handleUnlockClick = () => {
    const element = freemiumState.featuresOfPremiumRef?.current;
    if (element) {
      const offsetPosition = element.offsetTop - 100;

      window.scrollTo({ top: offsetPosition, behavior: 'smooth' });
    }
  };

  return (
    <Box onClick={handleUnlockClick} css={{ backgroundColor: 'bg.softest', padding: '400', cursor: 'pointer' }}>
      <IconLockOutline fontColor="textMedium" size="sm" />
      <Text asChild textStyle="body-sm" color="text.subtle" css={{ marginLeft: '200' }}>
        <a>Upgrade for competitive market insights</a>
      </Text>
    </Box>
  );
};

export default PremiumUpgrade;
